export const PAGE_VISIBLE = 'global/PAGE_VISIBLE';
export const PageVisible = () => ({ type: PAGE_VISIBLE });

export const PAGE_HIDDEN = 'global/PAGE_HIDDEN';
export const PageHidden = () => ({ type: PAGE_HIDDEN });
